import IMask from 'imask'
import { useIMask } from 'react-imask'

import { Input } from '@ui/components/Input'

import { DateRangeFormatConfig } from './DateRangeFromTo'

interface MaskedDateInputProps {
  value: string
  config: DateRangeFormatConfig
  error?: string
  onChange: (value: string, date?: Date) => void
  ariaLabel?: string
}

export const MaskedDateInput = ({
  value,
  config,
  error,
  onChange,
  ariaLabel,
}: MaskedDateInputProps) => {
  const { ref } = useIMask<HTMLInputElement>(
    {
      mask: Date as unknown as InstanceType<typeof IMask.MaskedDate>,
      pattern: config.imaskPattern,
      lazy: true,
      overwrite: false,
      autofix: true,
      format: (date: Date) => config.format(date),
      parse: (str: string) => {
        const result = config.parse(str)
        return result instanceof Date ? result : new Date(NaN)
      },
      blocks: {
        d: { mask: IMask.MaskedRange, from: 1, to: 31, maxLength: 2 },
        m: { mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2 },
        Y: { mask: IMask.MaskedRange, from: 1000, to: 9999, maxLength: 4 },
      },
    },
    {
      onAccept: (maskedValue: string) => {
        const parsed = config.parse(maskedValue)
        onChange(maskedValue, parsed instanceof Date ? parsed : undefined)
      },
    }
  )

  return (
    <Input
      ref={ref}
      size='lg'
      variant='default'
      value={value}
      error={!!error}
      inputMode='numeric'
      placeholder={config.placeholder}
      dir='ltr'
      label=''
      aria-label={ariaLabel ?? config.placeholder}
    />
  )
}
